import type { InactiveMemberDto } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import { word } from "@/modules/core/utils/i18n"
import type { HUImage } from "@/modules/types/imageTypes"
import dayjs from "dayjs"

export class InactiveMemberEntity {
  constructor(
    public readonly memberId: string,
    public readonly firstname: string | null,
    public readonly lastname: string | null,
    public readonly username: string | null,
    public readonly avatar: HUImage | null,
    public readonly inscriptionDate: string | null,
    public readonly lastSlotDate: string,
    public readonly numberOfDays: number,
    public readonly purchaseName: string,
  ) {}

  static fromDto(dto: InactiveMemberDto): InactiveMemberEntity {
    return new InactiveMemberEntity(
      dto.boxMemberItemDto.id,
      dto.boxMemberItemDto.firstname,
      dto.boxMemberItemDto.lastname,
      dto.boxMemberItemDto.username,
      dto.boxMemberItemDto.avatar,
      dto.boxMemberItemDto.inscriptionDate,
      dto.lastDate,
      dto.numberOfDays,
      dto.purchaseName,
    )
  }

  getFullName(): string {
    return `${this.firstname ?? ""} ${this.lastname ?? ""}`
  }

  getInscriptionDateFormatted(): string | null {
    if (!this.inscriptionDate) return null
    return dayjs(this.inscriptionDate).format("L")
  }

  getLastSlotDateFormatted(): string {
    return dayjs(this.lastSlotDate).format("L")
  }

  getInactiveDaysLabel(): string {
    return `${this.numberOfDays}${word("global.day.label", { count: 1 })[0]}`
  }
}
